module.exports = __webpack_public_path__ + "static/media/private.c3ff689f.svg";